import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { MyLinesComponent } from './pages/my-lines/my-lines.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { AuthGuard } from './guards/auth.guard';
import { ClientsComponent } from './pages/clients/clients.component';
import { AdminGuard } from './guards/admin.guard';
import { LineDetailsComponent } from './pages/line-details/line-details.component';
import { SettingsProfilesComponent } from './pages/settings-profiles/settings-profiles.component';
import { GroupsComponent } from './pages/groups/groups.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, title: 'Iniciar sesión' },
  { path: 'mis-lineas', component: MyLinesComponent, title: 'Mis líneas', canActivate: [AuthGuard] },
  { path: 'configuraciones', component: SettingsComponent, title: 'Configuraciones', canActivate: [AuthGuard] },
  { path: 'clientes', component: ClientsComponent, title: 'Clientes', canActivate: [AuthGuard, AdminGuard] },
  { path: 'detalle-lineas/:id', component: LineDetailsComponent, title: 'Detalle de líneas', canActivate: [AuthGuard] },
  { path: 'perfiles', component: SettingsProfilesComponent, title: 'Perfiles de configuración', canActivate: [AuthGuard] },
  { path: 'grupos', component: GroupsComponent, title: 'Grupos', canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
